import classNames from 'classnames'
import { ButtonHTMLAttributes, FC } from 'react'
import Spinner from './Spinner'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary' | 'red'
  variant?: 'primary' | 'secondary' | 'third'
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
  className?: string
  loading?: boolean
}

const Button: FC<ButtonProps> = ({
  children,
  size = 'base',
  variant = 'primary',
  loading,
  type = 'button',
  color = 'primary',
  className,
  ...rest
}) => {
  return (
    <button
      className={classNames(
        className,
        'bg-white p-2 mb-4 px-4 rounded-xl border-[1px] shadow-lg border-gray-800 text-gray-800 text-sm font-semibold hover:bg-primary-500 transition-all'
      )}
      {...rest}
    >
      {loading && <Spinner size={10} style={{ marginRight: 10 }} />}
      {children}
    </button>
  )
}

export default Button
